import { Fragment, Component } from 'react';

import { BuildStatusesMap } from '../../types';
import { BuildSummary } from '../build-summary';
import { BuildStatusModalDialog } from '../modal-dialog';

import Trigger from './trigger';

export type BuildStatusProps = {
  builds: BB.BuildStatus[];
  showIcon?: boolean;
  routerPush?: (pathname: string) => void;
  ignoreStoppedBuildStatus?: boolean;
};

type State = {
  isDialogOpen: boolean;
};

// @ts-ignore TODO: fix noImplicitAny error here
function getBuildCounts(builds): BuildStatusesMap {
  const statuses = {
    FAILED: 0,
    INPROGRESS: 0,
    STOPPED: 0,
    SUCCESSFUL: 0,
  };

  // @ts-ignore TODO: fix noImplicitAny error here
  return builds.reduce((acc, build) => {
    acc[build.state] += 1;

    return acc;
  }, statuses);
}

// eslint-disable-next-line import/no-default-export
export default class BuildStatusComponent extends Component<
  BuildStatusProps,
  State
> {
  state = {
    isDialogOpen: false,
  };

  onTrigger = () => {
    this.setState({ isDialogOpen: true });
  };

  onCloseDialog = () => {
    this.setState({ isDialogOpen: false });
  };

  render() {
    const { builds, showIcon, routerPush, ignoreStoppedBuildStatus } =
      this.props;
    const { isDialogOpen } = this.state;

    if (!builds || !builds.length) {
      return null;
    }

    return (
      <Fragment>
        <Trigger
          buildCounts={getBuildCounts(builds)}
          onTrigger={this.onTrigger}
          showIcon={showIcon}
          ignoreStoppedBuildStatus={ignoreStoppedBuildStatus}
        />
        {isDialogOpen && (
          <BuildStatusModalDialog onClose={this.onCloseDialog}>
            <BuildSummary builds={builds} routerPush={routerPush} />
          </BuildStatusModalDialog>
        )}
      </Fragment>
    );
  }
}
